var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZorb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 110 110",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "gzr",
    gradientTransform: "translate(66.4578 24.3575) scale(75.2908)",
    gradientUnits: "userSpaceOnUse",
    r: 1,
    cx: 0,
    cy: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "15.62%",
    stopColor: "hsl(24, 72%, 90%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "39.58%",
    stopColor: "hsl(24, 78%, 76%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "72.92%",
    stopColor: "hsl(69, 87%, 56%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "90.63%",
    stopColor: "hsl(73, 91%, 49%)"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "hsl(73, 91%, 48%)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5,5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100C77.6142 100 100 77.6142 100 50Z",
    fill: "url(#gzr)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "rgba(0,0,0,0.075)",
    fill: "transparent",
    strokeWidth: 1,
    d: "M50,0.5c27.3,0,49.5,22.2,49.5,49.5S77.3,99.5,50,99.5S0.5,77.3,0.5,50S22.7,0.5,50,0.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZorb);
export default __webpack_public_path__ + "static/media/zorb.79189f8ebfa829d2866d5d37eba53f37.svg";
export { ForwardRef as ReactComponent };